<template>
  <div>

    <el-tabs type="border-card" v-model="card_index">
      <el-tab-pane label="列表" name="MeterLogList">
        <MeterLogList  v-if="card_index==='MeterLogList'" />
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import MeterLogList from "./MeterLogList";

export default {
  name: "MeterLogMain",
  components: {MeterLogList},
  inject:['mainObj','componentId','setComponentId'],
  data(){
    return{
      card_index:"MeterLogList"
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Admin/EnergyConsumption/components/meter_log/MeterLogMain.vue